import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import Breadcrumb from "./../shared/breadcrumbs";
import { HeroImage } from "../shared/hero-image";
import styles from "../text-story-page/styles.m.css";
import { DfpAd } from "../../../../atoms/dfp-ad";
import { isPremium } from "../../../../../../isomorphic/data/story";

import stylesPhoto from "./styles.m.css";

function PhotoStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const renderfloatingBar = get(props, ["renderfloatingBar"], () => null);
  const renderStoryNewsletter = get(props, ["renderStoryNewsletter"], () => null);
  const renderHeaderPhoto = () => <HeroImage story={props.story} className={stylesPhoto["hero-image"]} />;
  const getStorycardLength = get(props, ["story", "cards"], () => null).length;

  return (
    <div className={`main-page ${stylesPhoto.photo} js-story-main-container`}>
      {!isPremium(props.story) && (
        <DfpAd story={props.story} className="hidden-mobile ad-tower-left" adtype="Tower_Left" placement="all" />
      )}
      <div className="page-content">
        <div className={`container ${stylesPhoto.breadcrumb}`}>
          <Breadcrumb subSection={section} config={props.config} />
        </div>
        <div className={`container ${styles["story-grid"]}`}>
          <div className={`${styles["main-content"]} ${stylesPhoto["main-content"]}`}>
            <article className={`${styles["story-body"]} ${stylesPhoto["story-body"]} js-story`}>
              {renderHeaderCard({ className: stylesPhoto["story-header"] })}
              {renderHeaderPhoto()}
              {props.story.cards.map((card, index) => {
                return (
                  <React.Fragment key={card.id}>
                    {index === 1 && renderStoryNewsletter()}
                    {index === 3 &&
                      !isPremium(props.story) && (
                        <DfpAd story={props.story} adtype="Inarticle_fork" placement="story" />
                      )}
                    <StoryCard key={card.id} card={card} story={props.story} />
                    {index !== getStorycardLength - 1
                      ? !isPremium(props.story) && <DfpAd story={props.story} adtype="Rectangle" placement="story" />
                      : ""}
                  </React.Fragment>
                );
              })}
              {renderFooter()}
            </article>
            {renderSocialMedia("show-desktop")}
            {renderfloatingBar()}
          </div>
          {renderSidebar()}
        </div>
      </div>
      {!isPremium(props.story) && (
        <DfpAd story={props.story} className="hidden-mobile ad-tower-right" adtype="Tower_Right" placement="all" />
      )}
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
PhotoStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { PhotoStory };
